
import { useStore } from '@/store'
import { defineComponent, ref } from 'vue'
import { computed } from 'vue'
import sideSettings from '@/settings/side-settings.json'
import FormOption from '@/components/Form/FormOption.vue'
import { ConfigurationActionTypes } from '@/store/modules/configuration/action-types'
import Analytics from '@/singletons/analytics'
import FormScrollableTab from '@/components/Abstract/FormScrollableTab.vue'

export default defineComponent({
  name: 'FormSide',
  components: {
    FormScrollableTab,
    FormOption
  },
  props: {
    index: Number
  },
  setup() {
    const store = useStore()
    const configName = ref('configSideId')
    const config = computed(() => store.getters[configName.value])
    const options = computed(() => sideSettings.sideTextures)

    const onClick = (option: any) => {
      store.dispatch(ConfigurationActionTypes.SET_CONFIG_SIDE, option.id)
      Analytics.instance.sendSideEvent(option.id)
    }

    return {
      config,
      configName,
      sideSettings,
      onClick,
      options,
    }
  }
})
